<div class="select-container">
  <div class="header">
    @if (label) {
      <div class="label">{{ label }}</div>
    }

  </div>

  @if (disabled) {
    <div class="dropdown">
      <button
        type="button"
        class="input-wrapper input"
        [disabled]="disabled"
      >
        @if (value) {
          <div class="text" [title]="selectedContact?.fullName">
            <span>{{ selectedContact?.fullName }}</span>

            @if (selectedContact?.nickname) {
              <span> ({{ selectedContact?.nickname }})</span>
            }

            @if (selectedContact?.email) {
              <span>; {{ selectedContact?.email }}</span>
            }

            @if (selectedContact?.phone) {
              <span>; {{ selectedContact?.phone | phone }}</span>
            }
          </div>
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <span class="icon ic-select-20"></span>
      </button>
    </div>
  } @else {
    <div
      ngbDropdown
      class="dropdown"
      (openChange)="$event && markAsTouched()"
    >
      <button
        type="button"
        class="input-wrapper input"
        ngbDropdownToggle
        [disabled]="disabled"
      >
        @if (value) {
          <div class="text" [title]="selectedContact?.fullName">
            <span>{{ selectedContact?.fullName }}</span>

            @if (selectedContact?.nickname) {
              <span> ({{ selectedContact?.nickname }})</span>
            }

            @if (selectedContact?.email) {
              <span>; {{ selectedContact?.email }}</span>
            }

            @if (selectedContact?.phone) {
              <span>; {{ selectedContact?.phone | phone }}</span>
            }
          </div>
        } @else {
          <div class="select-placeholder">{{ placeholder }}</div>
        }
        <span class="icon ic-select-20"></span>
      </button>
      <div ngbDropdownMenu class="dropdown-menu pb-0">
        @if (contacts.length) {
          <div class="contacts-options-wrapper">
            @for (contact of contacts; track $index) {
              <button
                ngbDropdownItem
                type="button"
                class="dropdown-button font-size-12 w-100"
                [class.selected]="contact.contactId === value"
                (click)="selectOption(contact)"
              >
                <div class="flex-grow-1">
                  <div class="contact-name-wrapper d-flex justify-content-between">
                    <div class="contact-name font-size-14">{{ contact.fullName }}</div>
                    <div class="nickname font-size-12">{{ contact.nickname }}</div>
                  </div>

                  <ul class="list-unstyled flex-grow-1 d-flex flex-column mb-0">
                    <li [hidden]="!contact.phone">
                      <span class="contact-element color-gray-600">Phone: </span>
                      <span>{{ contact.phone | phone }}</span>
                    </li>

                    <li [hidden]="!contact.email">
                      <span class="contact-element color-gray-600">Email: </span>
                      <span>{{ contact.email }}</span>
                    </li>

                    <li [hidden]="!contact.carbonCopy">
                      <span class="contact-element color-gray-600">CC: </span>
                      <span>{{ contact.carbonCopy }}</span>
                    </li>

                    <li [hidden]="!contact.blindCarbonCopy">
                      <span class="contact-element color-gray-600">CC: </span>
                      <span>{{ contact.blindCarbonCopy }}</span>
                    </li>
                  </ul>
                </div>

                @if (value == contact.contactId) {
                  <span class="icon ic-checkmark-circle-16"></span>
                }
              </button>
            }
          </div>
        } @else {
          <div class="no-options">{{ noOptionsText }}</div>
        }

        <div class="add-contact-wrapper" [hidden]="!entityId">
          <button
            type="button"
            class="btn btn-secondary w-100"
            (click)="onAddNewContact()"
          >
            Add New Contact
          </button>
        </div>
      </div>
    </div>
  }

  @if (displayValidationError) {
    <app-validation-error/>
  }
</div>





